import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { ref, onMounted, nextTick, reactive, watch } from 'vue';
import { api } from '@/server';

import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  name: 'IndustrySelect',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      default: '选择行业类型'
    }
  },
  emits: ['update:value'],
  setup(props, {
    emit
  }) {
    const industries = ref([]);
    const formValue = ref(props.value || '');
    watch(() => props.value, val => {
      formValue.value = val;
    }, {
      immediate: true
    });
    watch(formValue, val => {
      emit('update:value', val);
    });
    const fieldNames = reactive({
      label: 'name',
      value: 'id',
      children: 'children',
      disabled: 'childCount'
    });
    const {
      runAsync: getIndustryTree
    } = fetchApi(api.industry.getTree);
    const loadIndustries = async () => {
      const {
        error,
        rows
      } = await getIndustryTree({
        maxLevel: 3,
        search: ''
      });
      if (error) return;
      const transformSub = subItems => {
        if (!subItems) return subItems;
        return subItems.map(subItem => {
          const {
            childCount,
            children,
            ...more
          } = subItem;
          return {
            disabled: childCount > 0,
            childCount,
            children: transformSub(children),
            ...more
          };
        });
      };
      industries.value = rows.map(item => {
        const {
          childCount,
          children,
          ...more
        } = item;
        return {
          disabled: childCount > 0,
          childCount,
          children: transformSub(children),
          ...more
        };
      });
    };
    onMounted(() => {
      nextTick(async () => {
        await loadIndustries();
      });
    });
    return {
      industries,
      fieldNames,
      formValue
    };
  }
};